import translator from '@Components/Utilities/Translator';
import Modal from '@Components/Shared/Modals/Modal';

const DescriptiveTextModal = (props) => {

    const onClose = () => {
        props.toggleModal();
    };

    return (
        <Modal containerClassName='desctiptive-text-modal ts-modal-container' onEscapeKeyClose={onClose}>
            <Modal.Header onClose={onClose}>
                <Modal.Title>
                    {translator.translate('sandhills.tradepubwebsite.mvc.company')} {translator.translate('sandhills.tradepubwebsite.mvc.details')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span dangerouslySetInnerHTML={{ __html: props.Description }}></span>
                <div className='close-button'>
                    <button onClick={onClose}>{translator.translate('sandhills.closepage')}</button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default DescriptiveTextModal;